import React from 'react';
import LegalLayout from './LegalLayout';

export default function Terms() {
  return (
    <LegalLayout title="Публичная оферта" updated="16 сентября 2026 года">
      <p>
        Индивидуальный предприниматель Сидоренко Руслан Владимирович, ОГРНИП 317619600088799, ИНН 611300126009
        (далее — «Лицензиар»), настоящим предлагает любому заинтересованному
        дееспособному физическому лицу, индивидуальному предпринимателю или
        юридическому лицу (далее — «Лицензиат») заключить настоящий
        лицензионный договор (далее — «Договор», «Оферта») на изложенных ниже
        условиях.
      </p>

      <h2>1. Общие положения. Акцепт</h2>
      <p>
        1.1. Оферта является публичной в соответствии со ст. 437 ГК РФ и
        договором присоединения в понимании ст. 428 ГК РФ. Условия Договора
        одинаковы для всех Лицензиатов и не могут быть изменены Лицензиатом.
      </p>
      <p>1.2. Акцептом Оферты признается совершение Лицензиатом любого из следующих действий:</p>
      <ul>
        <li>а) регистрация учетной записи в Сервисе;</li>
        <li>б) оплата любого Тарифа;</li>
        <li>в) начало фактического использования любого функционала Сервиса;</li>
        <li>г) проставление отметки о согласии с условиями Оферты в интерфейсе Сервиса.</li>
      </ul>
      <p>
        1.3. С момента акцепта Договор считается заключенным в простой
        письменной форме. Акцепт означает полное и безоговорочное согласие
        Лицензиата с Офертой, а также с её неотъемлемыми частями: Политикой
        обработки персональных данных, Антиспам-политикой, Политикой обработки
        файлов cookie, Согласием на обработку персональных данных, оформляемым
        отдельно, и Тарифами, публикуемыми на Сайте или в Личном кабинете.
      </p>
      <p>
        1.4. Лицензиар вправе в любое время в одностороннем порядке изменять
        Оферту и её неотъемлемые части. Новая редакция вступает в силу с момента
        публикации, если в ней не указан иной срок. Лицензиат обязан
        самостоятельно отслеживать изменения. Продолжение использования Сервиса
        после публикации новой редакции означает согласие с ней.
      </p>
      <p>
        1.5. Договор регулируется правом Российской Федерации. Территория
        действия — Российская Федерация.
      </p>

      <h2>2. Термины и определения</h2>
      <p>
        2.1. <strong>Сервис</strong> — комплекс программ для ЭВМ и баз данных,
        исключительные права на который принадлежат Лицензиару, доступный через
        сеть Интернет по адресу www.mailora.ru и связанным доменным именам,
        предоставляемый по модели SaaS на условиях простой (неисключительной)
        лицензии. Функциональные возможности Сервиса включают:
      </p>
      <ul>
        <li>а) подключение Лицензиатом собственных почтовых ящиков (по протоколам IMAP/SMTP);</li>
        <li>б) загрузку и хранение баз получателей (контактов), предоставленных Лицензиатом;</li>
        <li>в) создание и настройку цепочек писем и автоматических рассылок по загруженным базам;</li>
        <li>г) настройку персонализации сообщений (подстановка переменных, индивидуальные блоки текста);</li>
        <li>д) встроенный инбокс — чтение и отправку писем по каждому подключенному ящику внутри интерфейса Сервиса без перехода в сторонние почтовые клиенты;</li>
        <li>е) подключение Telegram-аккаунта Лицензиата для получения сервисных уведомлений о ходе рассылок, ответах и событиях;</li>
        <li>ж) аналитику по рассылкам (отправки, открытия, ответы, отписки) в объеме, доступном в интерфейсе.</li>
      </ul>
      <p>
        2.2. <strong>Личный кабинет</strong> — защищенный персонализированный
        раздел Сервиса, доступ к которому предоставляется после регистрации.
      </p>
      <p>
        2.3. <strong>Сайт</strong> — совокупность веб-страниц по адресу www.mailora.ru,
        содержащих информацию о Сервисе, Тарифах и Договоре.
      </p>
      <p>
        2.4. <strong>База получателей (База)</strong> — совокупность контактных
        данных, загружаемая Лицензиатом в Сервис самостоятельно. Лицензиар не
        формирует Базу, не предоставляет её Лицензиату и не несет
        ответственности за её содержание и законность получения.
      </p>
      <p>
        2.5. <strong>Цепочка</strong> — последовательность электронных писем,
        настроенная Лицензиатом для автоматической отправки по адресатам из Базы
        с заданными интервалами.
      </p>
      <p>
        2.6. <strong>Авторассылка</strong> — автоматическая отправка сообщений по
        Базам получателей по заданному Лицензиатом расписанию или триггеру.
      </p>
      <p>
        2.7. <strong>Персонализация</strong> — настройка шаблонов писем с
        использованием переменных и условий, позволяющая формировать
        индивидуальные сообщения для каждого получателя.
      </p>
      <p>
        2.8. <strong>Инбокс</strong> — функциональная возможность Сервиса для
        чтения и отправки электронных писем по подключенным почтовым ящикам
        Лицензиата внутри интерфейса Сервиса.
      </p>
      <p>
        2.9. <strong>Тариф</strong> — совокупность условий предоставления доступа
        к Сервису (объем функционала, лимиты, срок, вознаграждение).
      </p>
      <p>
        2.10. <strong>Антиспам-политика</strong> — документ, устанавливающий
        обязательные правила использования Сервиса при email-коммуникациях.
        Нарушение квалифицируется как существенное нарушение Договора.
      </p>
      <p>
        2.11. <strong>Спам</strong> — массовая рассылка корреспонденции рекламного
        характера лицам, не выражавшим желания её получать.
      </p>
      <p>
        2.12. <strong>Жалоба на Спам</strong> — уведомление от получателя или
        антиспам-организации, блокировка серверов/URL Лицензиара, поступление
        FBL-жалобы.
      </p>
      <p>
        2.13. <strong>Представители</strong> — лица, допущенные Лицензиатом к
        Сервису и использующие его от имени Лицензиата.
      </p>
      <p>
        2.14. <strong>Telegram-уведомления</strong> — сервисные сообщения,
        направляемые Лицензиату через подключенный Лицензиатом Telegram-аккаунт,
        в объеме, предусмотренном функционалом Сервиса.
      </p>

      <h2>3. Предмет договора</h2>
      <p>
        3.1. Лицензиар предоставляет Лицензиату простую (неисключительную)
        лицензию на использование Сервиса в объеме и пределах, установленных
        Договором и выбранным Тарифом, а Лицензиат обязуется уплачивать
        вознаграждение.
      </p>
      <p>
        3.2. Право использования предоставляется исключительно для целей
        законной предпринимательской или иной профессиональной деятельности,
        связанной с установлением деловых контактов с юридическими лицами и ИП,
        а также с ведением деловой переписки.
      </p>
      <p>
        3.3. Сервис является программно-техническим инструментом,
        автоматизирующим отправку сообщений по Базам, загруженным Лицензиатом, и
        обработку входящей переписки. Лицензиар не предоставляет контактные
        данные, не формирует Базы и не осуществляет поиск сведений о получателях.
      </p>
      <p>
        3.4. Функционал Сервиса предоставляется «как есть», без явных или
        подразумеваемых гарантий точности, полноты, актуальности, пригодности для
        конкретных целей, отсутствия ошибок и бесперебойной работы.
      </p>
      <p>
        3.5. Программное обеспечение не передается в собственность. Лицензиару
        принадлежат все права, явно не предоставленные Лицензиату. ПО
        лицензируется, а не продается.
      </p>
      <p>
        3.6. Государственная регистрация прав на ПО не является обязательной и на
        момент заключения Договора может не проводиться (ст. 1262 ГК РФ).
      </p>
      <p>
        3.7. Лицензиар вправе оказывать Дополнительные услуги. Их состав, объем,
        сроки и стоимость определяются Счетом и/или Личным кабинетом.
      </p>

      <h2>4. Порядок использования Сервиса</h2>
      <p>
        4.1. Для доступа к Сервису Лицензиат проходит регистрацию, указывая адрес
        электронной почты . При регистрации
        Лицензиат подтверждает согласие с Договором, Политикой обработки
        персональных данных и Антиспам-политикой.
      </p>
      <p>
        4.2. Лицензиат самостоятельно подключает свои почтовые ящики, предоставляя
        необходимые данные доступа или проходя OAuth-авторизацию у почтового
        провайдера. Лицензиат гарантирует, что обладает всеми правами и
        полномочиями на подключение таких ящиков и использование их через Сервис.
      </p>
      <p>
        4.3. Лицензиат самостоятельно загружает Базы получателей и гарантирует
        наличие правовых оснований для обработки содержащихся в них данных и для
        направления сообщений.
      </p>
      <p>
        4.4. Лицензиат самостоятельно настраивает Цепочки, Авторассылки, шаблоны и
        параметры Персонализации. Лицензиар не контролирует содержание сообщений
        и не несет за него ответственности.
      </p>
      <p>
        4.5. Инбокс отображает переписку по подключенным ящикам в объеме, доступном
        через почтовые протоколы. Лицензиар не является оператором почтовой связи
        и не гарантирует сохранность копий переписки за пределами функционала
        Сервиса. Лицензиат обязан самостоятельно обеспечивать резервное
        копирование важной переписки.
      </p>
      <p>
        4.6. Telegram-уведомления являются сервисной функцией. Лицензиат
        самостоятельно подключает свой Telegram-аккаунт и несет ответственность за
        его безопасность. Лицензиар не несет ответственности за неполучение или
        несвоевременное получение уведомлений по причинам, зависящим от Telegram
        или каналов связи.
      </p>
      <p>
        4.7. Лицензиар вправе без объяснения причин и без предварительного
        уведомления ограничить или прекратить доступ к отдельным функциям Сервиса,
        изменить состав интеграций, ввести дополнительные технические или
        организационные ограничения, если это необходимо для соблюдения
        законодательства РФ, исполнения предписаний государственных органов или
        защиты законных интересов Лицензиара.
      </p>
      <p>
        4.8. Лицензиар не контролирует содержание направляемых сообщений и не несет
        за него ответственности.
      </p>

      <h2>5. Тарифы. Порядок расчетов</h2>
      <p>
        5.1. Размер вознаграждения, объем функционала, лимиты и срок определяются
        выбранным Тарифом. Актуальные Тарифы публикуются на Сайте или в Личном
        кабинете. Лицензиар вправе изменять Тарифы с уведомлением не менее чем за
        5 календарных дней путем размещения на Сайте, направления уведомления в
        Личный кабинет или на email.
      </p>
      <p>
        5.2. Оплата Тарифа — 100% предоплата. Прием платежей осуществляется через
        платежные сервисы, включая Robokassa, а также иными способами,
        указанными в интерфейсе. Лицензиар не хранит данные банковских карт.
      </p>
      <p>
        5.3. При выборе Тарифа с автоматическим продлением Лицензиат дает согласие
        на регулярное списание с привязанного платежного средства. Лицензиат
        вправе отключить автоплатеж в Личном кабинете или через поддержку.
      </p>
      <p>
        5.4. Документы, подтверждающие оплату, предоставляются в электронном виде
        через Личный кабинет, по email или через ЭДО.
      </p>
      <p>
        5.5. Датой оплаты является дата зачисления средств на счет Лицензиара. Все
        банковские услуги Лицензиат оплачивает за свой счет.
      </p>
      <p>
        5.6. Акты о предоставленном праве формируются по форме Лицензиара в Личном
        кабинете. Двусторонний акт не оформляется; его отсутствие не означает, что
        лицензия не предоставлена.
      </p>
      <p>
        5.7. Лицензиар вправе в одностороннем порядке определять Тарифы, виды и
        содержание лицензий.
      </p>
      <p>
        5.8. Фактическое неиспользование Сервиса после оплаты не позволяет
        требовать возврата средств.
      </p>
      <p>
        5.9. Обязательства Лицензиара считаются исполненными надлежащим образом при
        отсутствии письменных мотивированных возражений Лицензиата, направленных в
        пятидневный срок со дня окончания срока действия соответствующей лицензии.
      </p>

      <h2>6. Возврат денежных средств</h2>
      <p>
        6.1. Денежные средства за Тарифы возврату не подлежат, за исключением
        случая, предусмотренного п. 6.2.
      </p>
      <p>
        6.2. Возврат возможен исключительно при одновременном наличии всех условий:
      </p>
      <ul>
        <li>а) списание произведено в результате срабатывания функции автоматического продления с банковской карты;</li>
        <li>б) с момента списания до подачи заявления Лицензиат не совершил ни одного действия, влекущего использование платного функционала;</li>
        <li>в) заявление подано в поддержку в срок не позднее 5 календарных дней с даты списания.</li>
      </ul>
      <p>
        6.3. При удовлетворении заявления возврат производится за вычетом комиссий
        платежных систем и кредитных организаций. Срок — до 10 рабочих дней с даты
        получения полного комплекта сведений.
      </p>
      <p>
        6.4. Во всех иных случаях, включая отказ от Сервиса, неудовлетворенность
        результатами, техническую невозможность использования по причинам,
        зависящим от Лицензиата или третьих лиц, блокировку за нарушение Договора
        или Антиспам-политики, — возврат не производится.
      </p>

      <h2>7. Права и обязанности сторон</h2>
      <p>7.1. <strong>Лицензиар обязуется:</strong></p>
      <ul>
        <li>а) предоставить доступ к Сервису в объеме и на условиях выбранного Тарифа при надлежащей оплате;</li>
        <li>б) прилагать разумные усилия для обеспечения работоспособности Сервиса, за исключением периодов технических работ и обстоятельств, не зависящих от Лицензиара;</li>
        <li>в) обеспечивать конфиденциальность сведений о Лицензиате в соответствии с Политикой обработки персональных данных;</li>
        <li>г) рассматривать обращения Лицензиата в разумные сроки;</li>
        <li>д) хранить в тайне конфиденциальную информацию, полученную от Лицензиата, и не использовать Базу получателей Лицензиата, включая запрет на сдачу в аренду и продажу.</li>
      </ul>
      <p>7.2. <strong>Лицензиар вправе:</strong></p>
      <ul>
        <li>а) изменять функциональные возможности Сервиса, состав интеграций, Тарифы и технические параметры;</li>
        <li>б) приостанавливать, ограничивать или прекращать доступ к Сервису при нарушении Договора, Антиспам-политики, законодательства, а также при угрозе безопасности Сервиса, пользователей или третьих лиц;</li>
        <li>в) привлекать третьих лиц для обеспечения функционирования Сервиса (хостинг, платежные системы, аналитика, сервисы доставки уведомлений);</li>
        <li>г) осуществлять доступ уполномоченных сотрудников к учетным записям и данным Лицензиата для поддержки, расследования нарушений, безопасности и исполнения требований законодательства;</li>
        <li>д) направлять информационные, сервисные и маркетинговые сообщения при наличии согласия;</li>
        <li>е) блокировать доступ к функции отправки рассылок при нарушениях Антиспам-политики, в том числе при отсутствии предварительных согласий получателей. Блокировка осуществляется немедленно без уведомления;</li>
        <li>ж) блокировать доступ при отсутствии оплаты (с уведомлением за 24 часа), при превышении лимитов Тарифа (до апгрейда), при паразитном трафике (DoS/DDoS), при подозрении на недостоверность данных, при несанкционированном доступе к Личному кабинету;</li>
        <li>з) осуществлять агрегацию, группировку и систематизацию обезличенных статистических данных и использовать их без согласия Лицензиата, в том числе предоставлять третьим лицам;</li>
        <li>и) вносить изменения и обновления Сервиса без согласования, сохраняя функционал, на который рассчитывал Лицензиат;</li>
        <li>к) выполнять внеплановую приостановку доступа для аварийных, профилактических и ремонтных работ. Суммарное время недоступности по таким работам — не более 48 часов в месяц, если иной срок не требуется по техническим причинам. Время недоступности компенсации не подлежит.</li>
      </ul>
      <p>7.3. <strong>Лицензиат обязуется:</strong></p>
      <ul>
        <li>а) использовать Сервис исключительно в законных целях в соответствии с Договором, Антиспам-политикой и законодательством РФ;</li>
        <li>б) самостоятельно обеспечивать наличие всех правовых оснований для обработки контактных сведений, загруженных в Сервис, и для направления сообщений;</li>
        <li>в) обеспечивать сохранность учетных данных, не передавать их третьим лицам и не предоставлять доступ к Личному кабинету;</li>
        <li>г) не использовать Сервис для спама, распространения вредоносного ПО, мошенничества, распространения запрещенной информации;</li>
        <li>д) своевременно и в полном объеме оплачивать Тарифы;</li>
        <li>е) самостоятельно и регулярно знакомиться с актуальной редакцией Договора и связанных документов;</li>
        <li>ё) не включать в Базу лиц, не давших согласие на получение сообщений, и удалять отказавшихся;</li>
        <li>ж) не совершать действий, нарушающих работоспособность Сервиса;</li>
        <li>з) не повреждать, не блокировать и не перегружать сети и серверы; в противном случае возместить убытки, а Лицензиар вправе приостановить Договор до прекращения нарушений и компенсации;</li>
        <li>и) самостоятельно нести расходы на доступ к сети Интернет и трафик;</li>
        <li>к) самостоятельно обеспечивать резервное копирование важной переписки и данных.</li>
      </ul>
      <p>7.4. <strong>Лицензиату запрещается:</strong></p>
      <ul>
        <li>а) использовать доступ в противоправных целях, направлять контент, который может рассматриваться как оскорбительный, вредный, вводящий в заблуждение, мошеннический, аморальный, непристойный, порнографический, расистский, этнически оскорбительный, угрожающий, клеветнический, содержащий ненавистнические высказывания, ненормативную лексику, азартные игры, дискриминацию, вредоносное ПО, предложения быстрого заработка, финансовые пирамиды, информацию о наркотиках, оружии, рецептурных препаратах, политическую агитацию и иные запрещенные цели;</li>
        <li>б) совершать мошеннические действия;</li>
        <li>в) загружать, использовать, создавать или передавать материалы, нарушающие Договор, права интеллектуальной собственности, права Лицензиара или третьих лиц, требования законодательства;</li>
        <li>г) использовать чужие фирменные наименования, товарные знаки, логотипы без законных оснований; по требованию Лицензиара предоставлять подтверждение прав;</li>
        <li>д) выдавать себя за другое лицо;</li>
        <li>е) указывать, что рассылка осуществляется от имени Сервиса;</li>
        <li>ж) вводить в заблуждение Лицензиара и третьих лиц;</li>
        <li>з) отчуждать или передавать право доступа к Сервису третьим лицам;</li>
        <li>и) предоставлять данные авторизации третьим лицам, за исключением санкционированного доступа Представителей;</li>
        <li>к) копировать, перерабатывать, распространять, модифицировать, адаптировать, деассемблировать, декомпилировать или иным образом пытаться получить исходный код;</li>
        <li>л) отключать или вмешиваться в функции безопасности, пытаться получить доступ к непредназначенным услугам и информации;</li>
        <li>м) использовать Сервис способом, который может прервать или нарушить его нормальную функциональность;</li>
        <li>н) осуществлять рассылку, противоречащую законодательству, включая Закон «О рекламе» и Закон «О защите детей от информации»;</li>
        <li>о) осуществлять перепродажу, распространение, публикацию или иную передачу третьим лицам контактных сведений, загруженных в Сервис, а равно формировать на их основе базы данных для предоставления третьим лицам. Сведения могут использоваться исключительно для собственной деятельности по установлению деловых контактов;</li>
        <li>п) совершать иные действия, запрещенные законодательством.</li>
      </ul>

      <h2>8. Персональные данные. Конфиденциальность. Разграничение ролей</h2>
      <p>
        8.1. Обработка персональных данных Лицензиата (email, идентификатор
        Telegram, телефон, IP-адрес, данные о браузере и устройстве, история
        действий) осуществляется Лицензиаром в соответствии с Политикой обработки
        персональных данных и отдельным Согласием.
      </p>
      <p>
        8.2. В отношении контактных сведений, загружаемых Лицензиатом в Базу,
        оператором персональных данных является Лицензиат. Лицензиар обрабатывает
        такие сведения по поручению Лицензиата исключительно в целях
        предоставления функционала Сервиса. Лицензиат самостоятельно обеспечивает
        правовые основания по ст. 6 Закона № 152-ФЗ.
      </p>
      <p>
        8.3. Лицензиат гарантирует наличие правовых оснований для обработки
        контактных сведений и направления сообщений, обязуется своими силами и за
        свой счет урегулировать претензии субъектов, контролирующих органов и
        третьих лиц и освобождает Лицензиара от ответственности по таким
        претензиям.
      </p>
      <p>
        8.4. Передача сведений о Лицензиате третьим лицам осуществляется в объеме,
        необходимом для работы Сервиса, и включает:
      </p>
      <ul>
        <li>платежным системам Robokassa — для приема и обработки платежей и рекуррентных списаний;</li>
        <li>системам аналитики Yandex Metrica — для сбора и анализа статистики;</li>
        <li>сервисам доставки уведомлений (включая Telegram) — для направления сервисных сообщений.</li>
      </ul>
      <p>
        8.5. Базы данных, в которых обрабатываются сведения о Лицензиатах и данные
        Сервиса, размещаются на технических средствах на территории РФ.
      </p>
      <p>
        8.6. Лицензиар обеспечивает функционирование реестра исключений
        (стоп-листа). Любое лицо вправе направить требование о прекращении
        обработки на contact@mailora.ru. Сведения из реестра
        блокируются к отправке через Сервис для всех Лицензиатов. Лицензиат
        обязуется не направлять сообщения лицам, заявившим отказ, и не обходить
        реестр.
      </p>
      <p>
        8.7. Лицензиар обязуется не использовать Базу получателей Лицензиата иным
        образом, включая запрет на сдачу в аренду, продажу и обеспечение
        недоступности для третьих лиц.
      </p>
      <p>
        8.8. Стороны соблюдают конфиденциальность документации и информации,
        полученной в рамках Договора. Не считается нарушением предоставление
        информации органам государственной власти по мотивированному требованию.
      </p>
      <p>
        8.9. По обращению Лицензиата, а также после прекращения Договора, Лицензиар
        удаляет со своих носителей все данные и резервные копии, содержащие
        персональную информацию Лицензиата и его Базы получателей.
      </p>
      <p>
        8.10. Факт заключения Договора не является конфиденциальным. Любой устный
        или письменный обмен информацией и переписка являются конфиденциальными.
      </p>

      <h2>9. Ответственность сторон. Ограничение ответственности. Возмещение убытков</h2>
      <p>
        9.1. Лицензиар не несет ответственности перед Лицензиатом или третьими
        лицами за:
      </p>
      <ul>
        <li>а) любые прямые или косвенные убытки, включая упущенную выгоду, потерю данных, ущерб деловой репутации, возникшие в связи с использованием или невозможностью использования Сервиса;</li>
        <li>б) точность, полноту, актуальность или пригодность шаблонов, персонализации и результатов рассылок;</li>
        <li>в) действия или бездействие третьих лиц, включая почтовых провайдеров, платежные системы, хостинг-провайдеров, операторов связи, Telegram;</li>
        <li>г) решения почтовых провайдеров о фильтрации, блокировке, помещении в спам или иной обработке сообщений;</li>
        <li>д) содержание, правовые последствия и результаты использования загруженных Баз и направленных сообщений;</li>
        <li>е) временную полную или частичную недоступность Сервиса, вызванную техническими работами, сбоями сетей связи, действиями третьих лиц или обстоятельствами непреодолимой силы;</li>
        <li>ж) неполучение или несвоевременное получение получателем сообщений ввиду блокировки ящика, отказа сервера, технологии Greylisting, наличия ссылок в черных списках URL и иных причин;</li>
        <li>ё) временные сбои и перерывы в работе, потерю информации, сохранность, правильность и своевременность её передачи и доставки;</li>
        <li>з) надежность, качество и скорость работы каналов связи и сторонних сервисов;</li>
        <li>и) правильность функционирования программного и аппаратного обеспечения третьих лиц;</li>
        <li>к) сохранность переписки за пределами функционала Инбокса и необходимость самостоятельного резервного копирования.</li>
      </ul>
      <p>
        9.2. Совокупный размер ответственности Лицензиара по любым требованиям
        ограничивается суммой, фактически уплаченной Лицензиатом за 3 календарных
        месяца, непосредственно предшествующих моменту возникновения требования.
        В любом случае размер ответственности не может превышать 20000 рублей.
        Ограничения не применяются к видам ответственности, которые не могут быть
        исключены или ограничены по закону.
      </p>
      <p>
        9.3. Ни одна из Сторон не несет ответственности за упущенную выгоду, доходы
        или косвенные, особые, случайные, покрывающие или штрафные убытки, будь то
        действие по контракту или деликт, независимо от теории ответственности,
        даже если Стороне было сообщено о возможности такого ущерба. Исключение не
        применяется в степени, запрещенной законом.
      </p>
      <p>
        9.4. Лицензиат несет полную и исключительную ответственность за все свои
        действия при использовании Сервиса, соблюдение законодательства,
        содержание сообщений и любые претензии третьих лиц.
      </p>
      <p>
        9.5. Лицензиат обязуется возместить Лицензиару в полном объеме все убытки,
        включая штрафы государственных органов, судебные расходы, расходы на
        юридическую помощь, суммы, выплаченные третьим лицам, возникшие вследствие
        нарушения Лицензиатом Договора, Антиспам-политики или законодательства.
      </p>
      <p>
        9.6. В случае предъявления к Лицензиару претензий, исков или предписаний в
        связи с рассылками Лицензиата, Лицензиат обязан немедленно предоставить
        запрашиваемую информацию, способствовать урегулированию и возместить все
        убытки.
      </p>
      <p>
        9.7. ПО предоставляется «как есть» (AS IS). Лицензиар не несет
        ответственности за проблемы совместимости, несоответствие результатов
        ожиданиям, последствия использования или неиспользования ПО. ПО не
        предназначено для использования в опасных средах и системах
        жизнеобеспечения.
      </p>
      <p>
        9.8. Лицензиар вправе в любое время изменять оформление, содержание, список
        инструментов и платных функций, изменять или дополнять ПО, серверные
        приложения, изменять функционал или закрывать любой инструмент без
        предварительного уведомления, не неся ответственности за прекращение
        доступа к таким инструментам.
      </p>
      <p>
        9.9. Настолько, насколько допускается законом, Лицензиар отказывается от
        явных или подразумеваемых гарантий, которые могли бы предоставляться на
        основании закона, предшествующих заявлений, обычая или в связи с
        предоставлением прав. Лицензиар не гарантирует постоянную доступность и
        работоспособность сайтов и ПО, их работу непрерывно, бесперебойно и без
        ошибок.
      </p>
      <p>
        9.10. Ограничения и исключения раздела 9 действуют в максимальной степени,
        разрешенной законом.
      </p>

      <h2>10. Защита предоставляемых прав</h2>
      <p>
        10.1. В течение срока действия Договора Лицензиат обязуется не оспаривать
        права интеллектуальной собственности Лицензиара и не содействовать этому.
      </p>
      <p>
        10.2. О случаях противоправного использования ПО, ставших известными,
        Лицензиат уведомляет Лицензиара в течение 1 рабочего дня.
      </p>
      <p>
        10.3. При предъявлении к Лицензиату претензий или исков о нарушении прав
        интеллектуальной собственности третьих лиц в связи с исполнением Договора,
        при отсутствии вины Лицензиата, Лицензиат уведомляет Лицензиара в течение
        1 рабочего дня, а Лицензиар принимает меры для урегулирования.
      </p>
      <p>
        10.4. Если претензии связаны с нарушением Лицензиатом условий Договора,
        Лицензиат урегулирует их самостоятельно, за свой счет и без привлечения
        Лицензиара либо возмещает все расходы Лицензиара.
      </p>

      <h2>11. Обстоятельства непреодолимой силы</h2>
      <p>
        11.1. Стороны освобождаются от ответственности за частичное или полное
        неисполнение обязательств, если оно вызвано обстоятельствами непреодолимой
        силы: стихийные бедствия, пожары, наводнения, землетрясения, эпидемии,
        аварии, взрывы, военные действия, террористические акты, массовые
        беспорядки, забастовки, изменения законодательства, делающие исполнение
        невозможным, сбои в сетях электросвязи и электроснабжения, действия
        третьих лиц, направленные на нарушение работоспособности Сервиса.
      </p>
      <p>
        11.2. Сторона, для которой создалась невозможность исполнения, уведомляет
        другую Сторону в разумный срок, а при необходимости прикладывает документ,
        выданный Торгово-промышленной палатой. Срок исполнения переносится
        соразмерно времени действия обстоятельств.
      </p>
      <p>
        11.3. Если обстоятельства продолжаются более 1 месяца, любая Сторона вправе
        отказаться от Договора в одностороннем порядке, уведомив другую Сторону.
      </p>
      <p>
        11.4. Возникновение обстоятельств не является основанием для отказа
        Лицензиата от оплаты за право, предоставленное до их возникновения.
      </p>

      <h2>12. Срок действия. Изменение и расторжение</h2>
      <p>
        12.1. Договор вступает в силу с момента акцепта и действует в течение срока
        действия оплаченного Тарифа. При отсутствии действующего оплаченного
        Тарифа доступ к платным функциям может быть ограничен, при этом Договор
        продолжает регулировать отношения в части возникших прав и обязанностей и
        использования бесплатного функционала (при наличии).
      </p>
      <p>
        12.2. Лицензиар вправе в одностороннем внесудебном порядке расторгнуть
        Договор или заблокировать доступ (полностью или в части) в случаях:
      </p>
      <ul>
        <li>а) нарушения Лицензиатом любого условия Договора или Антиспам-политики;</li>
        <li>б) неоплаты или просрочки оплаты;</li>
        <li>в) получения претензий третьих лиц или требований государственных органов, связанных с действиями Лицензиата;</li>
        <li>г) выявления использования Сервиса способами, создающими угрозу безопасности Сервиса, инфраструктуры, иных пользователей или деловой репутации Лицензиара;</li>
        <li>д) если процент Жалоб на Спам превысит 0,5% от количества адресатов в рассылках (но не менее 20 человек) в течение 15 дней подряд;</li>
        <li>е) отсутствия активности в Личном кабинете в течение 1 календарного года с момента последнего входа;</li>
        <li>ё) удаления Лицензиатом Личного кабинета;</li>
        <li>ж) предоставления неверных, недействительных или ложных контактных данных, неспособности поддерживать их в актуальном состоянии, передачи прав третьим лицам без согласия Лицензиара;</li>
        <li>з) если Лицензиар обязан прекратить или приостановить Договор по закону.</li>
      </ul>
      <p>
        12.3. При отсутствии активности в Личном кабинете (невход и/или отсутствие
        платежей) в течение 1 календарного года Лицензиар вправе отказать в
        предоставлении ПО и удалить Личный кабинет и материалы в полном или
        частичном объеме, прекратив Договор. Лицензиар может направить уведомление
        за 30, 7 и/или 1 календарный день. При отсутствии ответа и входа Лицензиар
        не несет ответственности за сохранение данных. Возврат стоимости
        оплаченных, но не предоставленных услуг регулируется разделом 6.
      </p>
      <p>
        12.4. При прекращении или приостановке Договора по основаниям п. 12.2
        уплаченные суммы и остаток неиспользованных средств возврату не подлежат.
      </p>
      <p>
        12.5. Лицензиат вправе в любое время прекратить использование Сервиса и
        потребовать удаления учетной записи, направив запрос на contact@mailora.ru. Лицензиар
        удаляет учетную запись и связанные данные в срок, не превышающий 10 рабочих
        дней, за исключением сведений, обязательное хранение которых предусмотрено
        законодательством.
      </p>
      <p>
        12.6. Лицензиат не вправе уступать права или переводить долг по Договору
        без предварительного письменного согласия Лицензиара. Лицензиар вправе
        уступать права и переводить долг без согласия Лицензиата с последующим
        уведомлением.
      </p>

      <h2>13. Применимое право. Порядок разрешения споров</h2>
      <p>
        13.1. Договор и все отношения, возникающие в связи с ним, регулируются
        материальным правом Российской Федерации.
      </p>
      <p>
        13.2. Все споры подлежат урегулированию путем переговоров. Для Лицензиатов
        — юридических лиц и ИП соблюдение досудебного претензионного порядка
        обязательно. Для Лицензиатов — физических лиц, использующих Сервис для
        личных нужд, претензионный порядок носит рекомендательный характер и не
        ограничивает право на обращение в суд. Срок рассмотрения претензии — 20
        календарных дней с даты получения. Споры рассматриваются в суде по месту
        нахождения Лицензиара, если иное не установлено законодательством.
      </p>
      <p>
        13.3. Если Лицензиатом выступает физическое лицо, использующее Сервис
        исключительно для личных, семейных, домашних и иных нужд, не связанных с
        предпринимательской деятельностью, к отношениям применяются положения
        Закона РФ «О защите прав потребителей» в части, не противоречащей правовой
        природе обязательств по предоставлению доступа к ПО по модели SaaS и
        условиям Договора.
      </p>
      <p>
        13.4. Претензионный порядок: Сторона направляет претензию заказным письмом.
        Срок ответа — 5 рабочих дней (для B2B — 20 календарных дней). При
        отсутствии ответа в установленный срок претензия считается принятой.
      </p>

      <h2>14. Прочие условия</h2>
      <p>
        14.1. Договор, Политика обработки персональных данных, Антиспам-политика,
        Политика обработки файлов cookie и Согласие на обработку персональных
        данных в совокупности составляют полное соглашение Сторон и заменяют все
        предшествующие переговоры, переписку и соглашения по данному предмету.
      </p>
      <p>
        14.2. Никакое положение Договора не может толковаться как создающее
        совместное предприятие, товарищество или отношения принципала и агента.
      </p>
      <p>
        14.3. Признание судом какого-либо положения недействительным или не
        подлежащим применению не влечет недействительности остальных положений.
      </p>
      <p>
        14.4. Лицензиар вправе вносить изменения в Договор и изменять стоимость
        права использования ПО в одностороннем порядке путем размещения измененного
        текста по адресу https://mailora.ru/terms, уведомляя Лицензиата по email за 10 дней до
        вступления изменений в силу. Лицензиат самостоятельно несет
        ответственность за ознакомление с новыми версиями. Лицензиат вправе
        отказаться от измененных условий, не заказывая, не оплачивая и не используя
        ПО; в таком случае Договор считается расторгнутым. Использование ПО после
        изменений означает согласие с новой редакцией.
      </p>
      <p>
        14.5. По всем вопросам, не урегулированным Договором, Стороны
        руководствуются законодательством РФ.
      </p>

      <h2>15. Реквизиты Лицензиара</h2>
      <p>
        Индивидуальный предприниматель Сидоренкко Руслан Владимирович
        <br />
        ОГРНИП: 317619600088799
        <br />
        ИНН: 611300126009
        <br />
        Адрес места нахождения (почтовой корреспонденции): contact@mailora.ru
        <br />
        Банк: ПАО КБ "ЦЕНТР-ИНВЕСТ" г. Ростов-на-Дону
        <br />
        Расчетный счет: 40802810000000016807
        <br />
        Корреспондентский счет: 30101810100000000762
        <br />
        БИК: 046015762
        <br />
        Адрес электронной почты технической поддержки: support@mailora.ru
        <br />
        Адрес электронной почты для административно-правовых вопросов: contact@mailora.ru
        <br />
        Адрес электронной почты для вопросов персональных данных: contact@mailora.ru
        <br />
        Режим работы: 9.00 - 18.00 Мск, за исключением праздничных и выходных дней.
        <br />
        Сайт: www.mailora.ru
        <br />
        Дата публикации настоящей редакции: 16.09.2026
        <br />
        Актуальная версия всегда доступна по адресу: https://mailora.ru/terms
      </p>

      <h2>Контакты</h2>
      <p>
        По любым вопросам:{' '}
        <a href="mailto:contact@mailora.ru">contact@mailora.ru</a>
      </p>
    </LegalLayout>
  );
}